import React from "react";
import Grid from "@mui/material/Grid2";
import { Box, Divider, Typography } from "@mui/material";
import arrow_right from "../assets/icons/arrow-right-simple.svg";
import { useNavigate } from "react-router-dom";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Topbar from "../layouts/Topbar";
const Reports = () => {
    const navigate = useNavigate();
    const reportLinks = [
        { title: 'Orders', path: '/admin/Reports/orders' },
        { title: 'Consultation', path: '/admin/Reports/Consultation' },
        // { title: 'Payments', path: '/admin/Reports/Payments' },
        { title: 'Staff', path: '/admin/Reports/Staff' },
    ];
    return (
        <>
            <Topbar />
            <section className='reports_section'>
                <div>
                    {/* <Grid className="reports-container" item size={{ xs: 12, sm: 12, md: 3, lg: 3 }}>
                        <Typography className="label">Reports</Typography>
                        <Divider
                            sx={{
                                borderColor: 'rgba(113, 131, 155, 0.3)',
                                borderBottomWidth: '0.8px'
                            }}
                        />
                        <div className="reports-inner">
                            <div className="reports-info" onClick={() => navigate('/admin/Reports/orders')}>
                                <Typography className="value">orders</Typography>
                                <img src={arrow_right} alt="arrow-right" />
                            </div>
                            <div className="reports-info" onClick={() => navigate('/admin/Reports/Consultation')}>
                                <Typography className="value">Consultation</Typography>
                                <img src={arrow_right} alt="arrow-right" />
                            </div>
                            <div className="reports-info" onClick={() => navigate('/admin/Reports/Payments')}>
                                <Typography className="value">Payments</Typography>
                                <img src={arrow_right} alt="arrow-right" />
                            </div>
                            <div className="reports-info" onClick={() => navigate('/admin/Reports/Staff')}>
                                <Typography className="value">Staff</Typography>
                                <img src={arrow_right} alt="arrow-right" />
                            </div>
                        </div>
                    </Grid> */}
                    <Box
                        sx={{
                            p: 3,
                            backgroundColor: 'white',
                            boxShadow: '0 0 10px rgba(0,0,0,0.05)',
                            borderRadius: 2,
                            maxWidth: 900,
                            mx: 'auto',
                        }}
                    >
                        <Typography variant="h6" sx={{ fontWeight: 'bold', mb: 2, fontSize: '24px' }}>
                            Reports
                        </Typography>
                        <Divider sx={{ borderBottomWidth: '0.8px', borderColor: 'rgba(113, 131, 155, 0.3)', mb: 2 }} />
                        {reportLinks.map((report) => (
                            <Box
                                key={report.title}
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                                className="Reports_box"
                                onClick={() => navigate(report?.path)}
                                sx={{ py: 1.5, borderBottom: '1px solid #f0f0f0', '&:last-child': { borderBottom: 0 } }}
                            >
                                <Typography color="primary" sx={{ textTransform: 'capitalize', fontSize: '20px' }}>
                                    {report.title}
                                </Typography>
                                <ChevronRightIcon sx={{ color: '#71839b' }} />
                            </Box>
                        ))}
                    </Box>
                </div>
            </section>
        </>
    )
}

export default Reports